/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateLightningWithdrawal} from '../api'

export const useMutationInitiateLightningWithdrawal = createReactQueryMutationHook('initiateLightningWithdrawal', initiateLightningWithdrawal)
